import React, { useEffect, useRef, useState } from 'react'
import './Pregister.css'
import { ToastContainer, toast } from 'react-toastify';
import back from "../../imgs/backexam.png";
import close from "../../imgs/close.png";
import { Co2Sharp, Face6TwoTone, FaxTwoTone } from '@mui/icons-material';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Document, Page, Text, View, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import Billprint from '../Billprint/Billprint';
import { useNavigate } from 'react-router-dom';
import Status from "../../imgs/statusmob.jpeg";
import { useTranslation } from "react-i18next";

const Pregister = (props) => {
    const { t } = useTranslation();
    const [input, setInput] = useState({ date1: "", date2: new Date().toISOString().substr(0, 10), knofrom: "", knoto: "", mobileuser: "" });
    const inputRefs = useRef([]);
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [print, setprint] = useState(false);
    const [showitr, setShowitr] = useState("No");
    const [zero, setZero] = useState("Yes");
    const cellRefs = useRef([]);
    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [customerData, setCustomerData] = useState([]);
    const navigate = useNavigate();
    const refprint = useRef(null);
    const refprintclose = useRef(null);
    const [rtype, setRtype] = useState("2");
    const [showother, setShowother] = useState("Yes");
    const [wait, setWait] = useState(false);
    const [mobileusers, setMobileusers] = useState([]);


    const handlertype = (kno) => {

        if (kno === "1") {
            setRtype("1");
        }
        else if (kno === "2") {
            setRtype("2");
        }
        else if (kno === "3") {
            setRtype("3");
        }
        else if (kno === "4") {
            setRtype("4");
        }
        else if (kno === "5") {
            setRtype("5");
        }
        else if (kno === "6") {
            setRtype("6");
        }
    }

    const handleprintclose = () => {
        refprintclose.current.click();
    }

    const handlePrint = () => {
        refprint.current.click();
    }

    const handleOtheractive = (event) => {
        var checked = event.target.checked;

        if (event.target.checked) {
            setShowother("Yes");
        }
        else {
            setShowother("No");
        }
    }

    async function getmobileusers() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getmobileusers.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setMobileusers(response.data);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        let firstDayOfMonth;
        let lastDayOfMonth;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth >= 1 && dayOfMonth <= 10) {
                firstDayOfMonth = 1;
                lastDayOfMonth = 10;
            } else if (dayOfMonth >= 11 && dayOfMonth <= 20) {
                firstDayOfMonth = 11;
                lastDayOfMonth = 20;
            } else if (dayOfMonth >= 21 && dayOfMonth <= 30) {
                firstDayOfMonth = 21;
                lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Last day of current month
            }
        }
        else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth >= 1 && dayOfMonth <= 15) {
                firstDayOfMonth = 1;
                lastDayOfMonth = 10;
            } else if (dayOfMonth >= 16 && dayOfMonth <= 30) {
                firstDayOfMonth = 16;
                lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Last day of current month
            }
        }

        if (firstDayOfMonth !== undefined && lastDayOfMonth !== undefined) {
            const formattedDate1 = new Date(currentYear, currentMonth, firstDayOfMonth).toLocaleDateString('en-CA');
            const formattedDate2 = new Date(currentYear, currentMonth, lastDayOfMonth).toLocaleDateString('en-CA');
            setInput(prevInput => ({
                ...prevInput,
                date1: formattedDate1,
                date2: formattedDate2
            }));
        }

        getmobileusers();

        getmaxno();


    }, []);

    async function getmaxno() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getmaxno.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data) {
                setInput(prevInput => ({
                    ...prevInput,
                    knofrom: "1",
                    knoto: response.data,
                }))
            }
            else {
                setInput(prevInput => ({
                    ...prevInput,
                    knofrom: "0",
                    knoto: "0"
                }))
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        const currentDate1 = new Date(input.date1);
        const dayOfMonth1 = currentDate1.getDate();
        const currentMonth1 = currentDate1.getMonth();
        const currentYear1 = currentDate1.getFullYear();

        let lastDayOfMonth1;

        if (localStorage.getItem("dur") === "10") {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) {
                lastDayOfMonth1 = 10;
            } else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) {
                lastDayOfMonth1 = 20;
            } else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) {
                lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); // Last day of selected month
            }
        }
        else if (localStorage.getItem("dur") === "15") {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) {
                lastDayOfMonth1 = 15;
            } else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) {
                lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); // Last day of selected month
            }
        }

        if (lastDayOfMonth1 !== undefined) {
            const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
            setInput(prevInput => ({
                ...prevInput,
                date2: formattedDate2
            }));
        }
        setDataSource([]);
        setTableFilter([]);
    }, [input.date1]);

    const getpregister = () => {
        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        if (input.knofrom === "" || input.knoto === "") {
            notifyerror("सभासद क्रमांक भरा");
            return;
        }
        let rawData = {
            date1: input.date1,
            date2: input.date2,
            knofrom: input.knofrom,
            knoto: input.knoto,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)
        axios.post('https://excellentdairy.com/dairy/php/cust/getpregister2.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            // console.log(response.data);
            if (response.data && response.data.length > 0) {
                setDataSource(response.data);
            }
            else {
                notifyerror("या कालावधीचे रजिस्टर उपलब्ध नाही!");
            }
            setWait(false);
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    const showprint = () => {

        if (rtype === '1') {
            localStorage.setItem("pregister1", "1");
        }
        else if (rtype === '2') {
            localStorage.setItem("pregister1", "2");
        }
        else if (rtype === '3') {
            localStorage.setItem("pregister1", "3");
        }
        else if (rtype === '4') {
            localStorage.setItem("pregister1", "4");
        }
        else if (rtype === '5') {
            localStorage.setItem("pregister1", "5");
        }
        else if (rtype === '6') {
            localStorage.setItem("pregister1", "6");
        }

        if (DataSource && DataSource.length > 0) {
            // console.log(showitr);
            localStorage.setItem("date1print", input.date1);
            localStorage.setItem("date2print", input.date2);
            localStorage.setItem("mobileuser", input.mobileuser);
            localStorage.setItem("showitr", showitr);
            localStorage.setItem("zero", zero);
            const url = "/pregisterprint";
            window.open(url, '_blank');
        }
        else {
            notifyerror("या कालावधीचे रजिस्टर उपलब्ध नाही!");
        }
    }

    const handleCellKeyPress = (e, rowIndex) => {
        if (e.key === 'Enter') {
            e.preventDefault();

            if (rowIndex + 1 < cellRefs.current.length) {
                const nextRow = cellRefs.current[rowIndex + 1];
                nextRow[0].focus();
            }
            e.target.blur(); // Remove focus from the cell
        } else if (isNaN(e.key) && e.key !== 'Backspace') {
            e.preventDefault(); // Prevent non-numeric input
        }
    };

    function handleEnterKey(event, currentIndex) {

        if (event.keyCode === 8) {
            if (event.target.name === "time") {
                setInput((prevInputSettings) => ({
                    ...prevInputSettings,
                    time: '',
                }));
            }
            else if (event.target.name === "type") {
                setInput((prevInputSettings) => ({
                    ...prevInputSettings,
                    type: '',
                }));
            }
        }

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            if (currentIndex === 2) {
                if (input.name !== "") {
                    nextIndex = currentIndex + 1;
                }
                else {
                    nextIndex = currentIndex;
                }
            }
            else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    const handleitr = (event) => {
        var checked = event.target.checked;

        if (event.target.checked) {
            setShowitr("Yes");
        }
        else {
            setShowitr("No");
        }
    }

    const handlezero = (event) => {
        var checked = event.target.checked;
        if (event.target.checked) {
            setZero("Yes");
        }
        else {
            setZero("No");
        }
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            // Make sure that the input is a string
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                // Create block
                var a = str.charCodeAt(i);
                // Bitwise XOR
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    const exportToExcel = () => {
        let wb = XLSX.utils.table_to_book(document.getElementById('myTablebill'), { sheet: "Sheet JS" });
        const ws = wb.Sheets["Sheet JS"];

        // Set column widths for specific columns (adjust the width values as needed)
        if (input.excelbank === "DCC Bank") {
            ws['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 20 }];
        } else {
            ws['!cols'] = [
                { wch: 10 }, { wch: 50 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
                { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
                { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
                { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }
            ];
        }

        const range = XLSX.utils.decode_range(ws['!ref']);

        // Format column 10 (index 9) to replace '/' with '-'
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 9 })];
            if (cell && typeof cell.v === 'string') cell.v = cell.v.replace(/\//g, '-');
        }

        // Prepend 'A' and ensure leading zeros are preserved for column 6 (index 5)
      

        // Ensure large numbers in column 3 (index 2) are treated as strings
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 2 })];
            if (cell) {
                cell.v = String(cell.v ?? "");
                cell.t = 's';
            }
        }

        // ✅ Gray style for Heading + Total row
        const grayFill = {
            patternType: "solid",
            fgColor: { rgb: "D9D9D9" } // light gray
        };

        const applyRowStyle = (rowIndex) => {
            for (let C = 0; C <= range.e.c; ++C) {
                const addr = XLSX.utils.encode_cell({ r: rowIndex, c: C });
                if (ws[addr]) {
                    ws[addr].s = ws[addr].s || {};
                    ws[addr].s.fill = grayFill;
                    ws[addr].s.font = { ...(ws[addr].s.font || {}), bold: true };
                }
            }
        };

        // Heading row (first row)
        applyRowStyle(0);

        // Total row (last row in sheet)
        applyRowStyle(range.e.r);

        // Save the file
        XLSX.writeFile(wb, `Advance Report (${input.date1} ते ${input.date2}).xlsx`);
    };


   return (
  <>
    <button
      type="button"
      className="btn btn-primary"
      data-bs-toggle="modal"
      hidden={true}
      ref={refprint}
      data-bs-target="#printinput"
    />

    <div
      className="modal fade"
      id="printinput"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="printinputLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="printinputLabel"></h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              ref={refprintclose}
              aria-label="Close"
            />
          </div>

          <div className="modal-body">
            <h5 className="modal-title">{t("pregister.modal.title")}</h5>

            <div className="radiotheme">
              <div className="form-check">
                <input
                  onClick={() => handlertype("2")}
                  className="form-check-input"
                  type="radio"
                  name="printDesign"
                  id="design1"
                  value="2"
                />
                <label className="form-check-label radiolabel" htmlFor="design1">
                  {t("pregister.modal.design", { no: 1 })}
                </label>
              </div>

              <div className="form-check">
                <input
                  onClick={() => handlertype("3")}
                  className="form-check-input"
                  type="radio"
                  name="printDesign"
                  id="design2"
                  value="3"
                />
                <label className="form-check-label radiolabel" htmlFor="design2">
                  {t("pregister.modal.design", { no: 2 })}
                </label>
              </div>

              <div className="form-check">
                <input
                  onClick={() => handlertype("4")}
                  className="form-check-input"
                  type="radio"
                  name="printDesign"
                  id="design3"
                  value="4"
                />
                <label className="form-check-label radiolabel" htmlFor="design3">
                  {t("pregister.modal.design", { no: 3 })}
                </label>
              </div>
            </div>

            <div className="radiotheme">
              <div className="form-check">
                <input
                  onClick={() => handlertype("5")}
                  className="form-check-input"
                  type="radio"
                  name="printDesign"
                  id="design4"
                  value="5"
                />
                <label className="form-check-label radiolabel" htmlFor="design4">
                  {t("pregister.modal.design", { no: 4 })}
                </label>
              </div>

              <div className="form-check">
                <input
                  onClick={() => handlertype("1")}
                  className="form-check-input"
                  type="radio"
                  name="printDesign"
                  id="design5"
                  value="1"
                />
                <label className="form-check-label radiolabel" htmlFor="design5">
                  {t("pregister.modal.design", { no: 5 })}
                </label>
              </div>

              <div className="form-check">
                <input
                  onClick={() => handlertype("6")}
                  className="form-check-input"
                  type="radio"
                  name="printDesign"
                  id="design6"
                  value="6"
                />
                <label className="form-check-label radiolabel" htmlFor="design6">
                  {t("pregister.modal.design", { no: 6 })}
                </label>
              </div>
            </div>

            <div className="mb-2">
              <span className="subheadsank">{t("pregister.modal.mobileUserLabel")}</span>
              <select
                onKeyDown={(e) => handleEnterKey(e, 6)}
                ref={(ref) => (inputRefs.current[6] = ref)}
                className={"form-control"}
                autoComplete="off"
                id="mobileuser"
                name="mobileuser"
                value={input.mobileuser}
                onChange={handleChange}
              >
                <option key={0} value={t("pregister.modal.mobileUserPlaceholder")}>
                  {t("pregister.modal.mobileUserPlaceholder")}
                </option>

                {mobileusers
                  ? mobileusers.map((opt2, index) => (
                      <option key={index + 1} value={opt2.name}>
                        {opt2.name}
                      </option>
                    ))
                  : ""}
              </select>
            </div>

            <span className="note">{t("pregister.modal.printSettings")}</span>

            <div hidden className="form-check check">
              <input className="form-check-input" type="checkbox" value="" onChange={handleitr} id="activeother" />
              <span className="checklbl" htmlFor="activeother">
                {t("pregister.modal.otherDeductColumns")}
              </span>
            </div>

            <div className="form-check check">
              <input
                checked={zero === "Yes"}
                className="form-check-input"
                type="checkbox"
                value=""
                onChange={handlezero}
                id="zeroliterprint"
              />
              <span className="checklbl" htmlFor="zeroliterprint">
                {t("pregister.modal.zeroLiterPrint")}
              </span>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>
              {t("pregister.modal.btnClose")}
            </button>
            <button type="button" className="btn btn-danger" onClick={showprint}>
              {t("pregister.modal.btnOk")}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div className="sanklanmain">
      <div className="firstrowsank">
        <img onClick={props.visibility} className="back" src={back} alt="" />

        <div className="colmain">
          <div className="firstrow2">
            <div className="rowbill">
              <div className="mb-2">
                <span className="subheadsank">{t("pregister.filters.date")}</span>
                <input
                  onKeyDown={(e) => handleEnterKey(e, 0)}
                  ref={(ref) => (inputRefs.current[0] = ref)}
                  type="date"
                  className="form-control"
                  autoComplete="off"
                  id="date1"
                  name="date1"
                  value={input.date1}
                  onChange={handleChange}
                />
              </div>

              <span className="subheadbill">{t("pregister.filters.to")}</span>

              <div className="mb-2">
                <span className="subheadsank">{t("pregister.filters.date")}</span>
                <input
                  disabled
                  onKeyDown={(e) => handleEnterKey(e, 1)}
                  ref={(ref) => (inputRefs.current[1] = ref)}
                  type="date"
                  className="form-control"
                  autoComplete="off"
                  id="date2"
                  name="date2"
                  value={input.date2}
                  onChange={handleChange}
                />
              </div>

              <span className="subheadbill se"> || </span>

              <div className="mb-2 se">
                <span className="subheadsank">{t("pregister.filters.accountNoFrom")}</span>
                <input
                  disabled
                  onKeyDown={(e) => handleEnterKey(e, 2)}
                  ref={(ref) => (inputRefs.current[2] = ref)}
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  id="knofrom"
                  name="knofrom"
                  value={input.knofrom}
                  onChange={handleChange}
                />
              </div>

              <span className="subheadbill">{t("pregister.filters.to")}</span>

              <div className="mb-2">
                <span className="subheadsank">{t("pregister.filters.accountNoTo")}</span>
                <input
                  disabled
                  onKeyDown={(e) => handleEnterKey(e, 3)}
                  ref={(ref) => (inputRefs.current[3] = ref)}
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  id="knoto"
                  name="knoto"
                  value={input.knoto}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-2">
                {wait ? (
                  <button type="submit" id="show" className="btn btn-primary mx-1 sanksmall">
                    {t("pregister.buttons.loading")}
                  </button>
                ) : (
                  <button
                    onClick={getpregister}
                    ref={(ref) => (inputRefs.current[4] = ref)}
                    type="submit"
                    id="show"
                    className="btn btn-primary mx-1 sanksmall"
                  >
                    {t("pregister.buttons.viewRegister")}
                  </button>
                )}

                <button onClick={exportToExcel} type="submit" id="print" className="btn btn-primary mx-1 sanksmall">
                  {t("pregister.buttons.excel")}
                </button>

                <button
                  onClick={handlePrint}
                  ref={(ref) => (inputRefs.current[4] = ref)}
                  type="submit"
                  id="print"
                  className="btn btn-primary mx-1 sanksmall"
                >
                  {t("pregister.buttons.print")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="firstrow2">
        <div className="table-containerbill">
          <table id="myTablebill" className="table table-bordered">
            <thead>
              <tr>
                <th className="thsmall" scope="col">{t("pregister.table.accountNo")}</th>
                <th className="thlarge" scope="col">{t("pregister.table.name")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.buffaloLiter")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.cowLiter")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.totalLiter")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.buffaloAmount")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.cowAmount")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.totalAmount")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.totalBill")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.prevDeposit")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.depositDeduct")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.totalDeposit")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.prevAdvanceBalance")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.advanceOn")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.totalAdvance")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.advanceDeduct")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.newAdvanceBalance")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.prevKhadyBalance")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.khadyOn")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.totalKhady")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.khadyDeduct")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.newKhadyBalance")}</th>

                <th className="thsmall" scope="col">{t("pregister.table.otherDeductPerLiter")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.otherDeductPerBill")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.transport")}</th>
                <th className="thsmall" scope="col">{t("pregister.table.netPayable")}</th>
              </tr>
            </thead>

            <tbody>
              {DataSource &&
                DataSource.map((user, index) => (
                  <tr key={index}>
                    <td className="thsmall">{user.kno}</td>
                    <td className="thsmall">{user.cname}</td>

                    <td className="thsmall2">{parseFloat(user.mhliter).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.gayliter).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.tliter).toFixed(2)}</td>

                    <td className="thsmall2">{parseFloat(user.mhamt).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.gayamt).toFixed(2)}</td>

                    <td className="thsmall2">
                      {(
                        ((v) => (Number.isFinite(v) ? v : 0))(Number(user?.mhamt)) +
                        ((v) => (Number.isFinite(v) ? v : 0))(Number(user?.gayamt))
                      ).toFixed(2)}
                    </td>

                    <td className="thsmall2">{parseFloat(user.billamt).toFixed(2)}</td>

                    <td className="thsmall2">{parseFloat(user.magilthev).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.cthev).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.newthev).toFixed(2)}</td>

                    <td className="thsmall2">{parseFloat(user.madv).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.cadv).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.tadv).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.advkapat).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.newadv).toFixed(2)}</td>

                    <td className="thsmall2">{parseFloat(user.mkhadya).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.ckhadya).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.tkhadya).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.khadyakapat).toFixed(2)}</td>
                    <td className="thsmall2">{parseFloat(user.newkhadya).toFixed(2)}</td>

                    <td className="thsmall2">{user.ikapatliter ? parseFloat(user.ikapatliter).toFixed(2) : 0}</td>
                    <td className="thsmall2">{user.ikapatbill ? user.ikapatbill : 0}</td>
                    <td className="thsmall2">{user.vah ? parseFloat(user.vah) : 0}</td>

                    <td className={(parseFloat(user.ada) || 0) > 0 ? "thsmallgreen" : "thsmallred"}>
                      {parseFloat(user.ada) ? parseFloat(user.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2) : 0}
                    </td>
                  </tr>
                ))}
            </tbody>

            <tfoot>
              <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                <td className="thsmall" colSpan="2">{t("pregister.totalRow.total")}</td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.mhliter), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.gayliter), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.mhliter) + parseFloat(u.gayliter), 0).toFixed(2)}</td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.mhamt), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.gayamt), 0).toFixed(2)}</td>
                <td className="thsmall2">
                  {DataSource.reduce((total, u) => total + (Number(u?.mhamt) || 0) + (Number(u?.gayamt) || 0), 0).toFixed(2)}
                </td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.billamt), 0).toFixed(2)}</td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.magilthev), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.cthev), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.newthev), 0).toFixed(2)}</td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.madv), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.cadv), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.tadv), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.advkapat), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.newadv), 0).toFixed(2)}</td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.mkhadya), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.ckhadya), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.tkhadya), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.khadyakapat), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + parseFloat(u.newkhadya), 0).toFixed(2)}</td>

                <td className="thsmall2">{DataSource.reduce((total, u) => total + (parseFloat(u.ikapatliter) || 0), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + (parseFloat(u.ikapatbill) || 0), 0).toFixed(2)}</td>
                <td className="thsmall2">{DataSource.reduce((total, u) => total + (parseFloat(u.vah) || 0), 0).toFixed(2)}</td>

                <td className="thsmall2">
                  {DataSource
                    .reduce((total, u) => total + ((parseFloat(u.ada) > 0 ? parseFloat(u.ada) : 0) || 0), 0)
                    .toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </>
);

}

export default Pregister
